import { Component, Input } from '@angular/core';

@Component({
  selector: 'loading',
  template: `
    <div [ngStyle]="{ 'background-color': backgroundColor }">
      <span class="d">.</span>
      <span class="d d-2">.</span>
      <span class="d d-3">.</span>
    </div>
  `,
  styles:[`
  div{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: pink;
    text-transform: uppercase;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica, sans-serif;
    font-size: 7.5em;
    position: fixed;
    top: 0px;
    width: 100%;
    z-index: 999999;
  }

  @keyframes dots {
    50% {
      transform: translateY(0.6rem);
    }
    100% {
      transform: translateY(0);
    }
  }

  .d {
    animation: dots 0.6s ease-out infinite;
    height: 240px;
  }
  .d-2 {
    animation-delay: 0.1s;
  }
  .d-3 {
    animation-delay: 0.2s;
  }
  `]
})
export class LoadingComponent {
  @Input() backgroundColor:string; 
  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/loading/loading.component.ts